import { BaseService } from "./base.service";
import axios from "axios";
import {
  CheckoutRequest,
  HistoryOrderResponse,
  MerchantResponse,
  OrderResponse,
  ProductIsReadyResponse,
  ProductResponse,
} from "./dtos/marketplace.dto";
import { BaseResponse } from "./dtos/base.dto";

interface MarketplaceServiceInterface {
  queries: {
    GET_DATA_PRODUCT: string;
    GET_PRODUCT_READY: string;
    GET_MARKETPLACE_MERCHANT: string;
    GET_MARKETPLACE_ORDERS: string;
  };
  products(
    jenis: string,
    toko: string,
    keyword?: string
  ): Promise<ProductResponse>;
  productIsReady(ids: string[]): Promise<ProductIsReadyResponse>;
  merchant(): Promise<MerchantResponse>;
  checkPin(): Promise<BaseResponse<boolean>>;
  createPin(pin: string): Promise<BaseResponse<boolean>>;
  checkout(payload: CheckoutRequest): Promise<BaseResponse<number[]>>;
  historyOrders(payload: {
    range: "WEEK" | "MONTH";
    status:
      | "ALL"
      | "KONFIRMASI"
      | "DIPROSES"
      | "DIKIRIM"
      | "DITERIMA PETUGAS"
      | "DITERIMA SANTRI"
      | "DIBATALKAN";
  }): Promise<HistoryOrderResponse>;
}
export const MarketplaceService: MarketplaceServiceInterface = {
  queries: {
    GET_DATA_PRODUCT: "GET_DATA_PRODUCT",
    GET_PRODUCT_READY: "GET_PRODUCT_READY",
    GET_MARKETPLACE_MERCHANT: "GET_MARKETPLACE_MERCHANT",
    GET_MARKETPLACE_ORDERS: "GET_MARKETPLACE_ORDERS",
  },

  products: async (jenis: string, toko: string, keyword?: string) => {
    try {
      const request = await axios.get<ProductResponse>(
        `https://iduorangtuaapi.sipond.id/api/marketplace/data-product/${jenis}/${toko}${
          keyword ? `/${keyword}` : ""
        }`,
        {
          headers: {
            token: process.env.REACT_APP_TOKEN_HEADER,
          },
        }
      );
      return {
        success: request.data.success,
        message: request.data.message,
        data: request.data.data,
      };
    } catch (error: any) {
      return BaseService.response(error, true);
    }
  },

  productIsReady: async (ids: string[]) => {
    try {
      const request = await BaseService.request().get<ProductIsReadyResponse>(
        "/marketplace/check-product-is-ready/" + ids.join(",")
      );
      return BaseService.response(request);
    } catch (error: any) {
      return BaseService.response(error, true);
    }
  },

  merchant: async () => {
    try {
      const request = await BaseService.request().get<MerchantResponse>(
        "/marketplace/merchants"
      );
      return BaseService.response(request);
    } catch (error: any) {
      return BaseService.response(error, true);
    }
  },

  checkPin: async () => {
    try {
      const request = await BaseService.request().get<BaseResponse<boolean>>(
        "/marketplace/check-pin"
      );
      return BaseService.response(request);
    } catch (error: any) {
      return BaseService.response(error, true);
    }
  },

  createPin: async (pin: string) => {
    try {
      const request = await BaseService.request().get<BaseResponse<boolean>>(
        `/marketplace/create-pin/${pin}`
      );
      return BaseService.response(request);
    } catch (error: any) {
      return BaseService.response(error, true);
    }
  },

  checkout: async (payload: CheckoutRequest) => {
    try {
      const request = await BaseService.request().post<BaseResponse<number[]>>(
        "/marketplace/checkout",
        payload
      );
      return BaseService.response(request);
    } catch (error: any) {
      return BaseService.response(error, true);
    }
  },

  historyOrders: async (payload: {
    range: "WEEK" | "MONTH";
    status:
      | "ALL"
      | "KONFIRMASI"
      | "DIPROSES"
      | "DIKIRIM"
      | "DITERIMA PETUGAS"
      | "DITERIMA SANTRI"
      | "DIBATALKAN";
  }) => {
    try {
      const request = await BaseService.request().get<HistoryOrderResponse>(
        `/marketplace/history-orders`,
        { params: payload }
      );
      return BaseService.response(request);
    } catch (error: any) {
      return BaseService.response(error, true);
    }
  },
};
